module.exports = __webpack_public_path__ + "assets/img/img-hotel-08.d10203dc.jpg";